const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/eCheckin/components/sections/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        finalizeTitle: 'Online Check-In abschliessen',
        finalizeContent:
            'Bitte bestätigen Sie, dass Ihre Angaben vollständig und korrekt sind, und schliessen Sie das Online-Check-in ab.<br/><b>Wichtig</b>: Nach Abschluss können Ihre Angaben <b>nicht mehr geändert werden</b>.',
    },
    __RELATIVE_SOURCE_FILE__
);
